<!-- <div class="upload-container" (click)="fileInput.click()" *ngIf="!photoLoading" title="{{'Add photo' | translate | async}}">
  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>
  <input style="display: none;" type="file"
         #fileInput
         (change)="onSelectPhoto($event)">
</div>
<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner> -->

<label class="upload-container"
       *ngIf="!photoLoading"
       title="{{'Add photo' | translate}}">

  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>

  <input
    type="file"
    accept="image/*"
    (change)="onSelectPhoto($event)"
    style="display: none;">
</label>

<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner>
